import { PureComponent } from "react";
import { FormattedMessage } from "react-intl";
import "./TechnicalErrorRegistrationExpired.scss";
import PropTypes from "prop-types";
import { ButtonLink } from "app/components/ui/ButtonLink/ButtonLink";

class TechnicalErrorRegistrationExpired extends PureComponent {
	render() {
		const { teasingEndDate } = this.props;

		const today = new Date();
		const endDate = new Date(teasingEndDate);

		const isTeasing = today <= endDate;

		return (
			<div className="technical-error">
				<div className="technical-error__intro">
					<FormattedMessage id="technical.error.registration.expired.message" />

					<div className="technical-error__cta">
						<ButtonLink
							variant="primary"
							size="lg"
							to={{ pathname: isTeasing ? "/teasing" : "/home/signup" }}
							data-testid={"go-to-signup-button"}
						>
							<FormattedMessage id="technical.error.registration.expired.cta.label" />
						</ButtonLink>
					</div>
				</div>
			</div>
		);
	}
}

TechnicalErrorRegistrationExpired.propTypes = {
	teasingEndDate: PropTypes.string,
};

export default TechnicalErrorRegistrationExpired;
